import React from 'react';
import { Component, PuzzleButton, PuzzleToolbar } from 'puzzle';
import dayjs from 'dayjs';
import { PROPS, STATE } from './Types';
import durationPlugin from 'dayjs/plugin/duration';

dayjs.extend(durationPlugin);

class Footer extends Component<PROPS, STATE> {
  public state: STATE = {};

  static defaultProps = {
    openActiveSessionsDialog: false,
    impersonatedUser: false
  };

  setLastLoginData = (initializeUserData: any) => {
    const { activeSessionsCount, dateLastLogin } = initializeUserData.userProfile.userInfo;
    const { pdInstanceIndicator } = initializeUserData;
    this.setState({
      numberOfActiveSessions: activeSessionsCount,
      dateLastLogin: new Date(dateLastLogin),
      pdInstanceIndicator
    });
  };

  /**
   * Sets number of current sessions
   *
   * @param numberOfActiveSessions
   */
  setNumberOfActiveSessions = (numberOfActiveSessions: number = 1) => {
    this.setState({
      numberOfActiveSessions
    });
  };

  /**
   * Open active sessions dialog
   */
  openActiveSessions = (e: any) => {
    e.preventDefault();
    const { openActiveSessionsDialog } = this.props;

    if (openActiveSessionsDialog) {
      this.dispatch('openActiveSessionsDialog');
    }
  };

  /**
   * Render session activity and last login info.
   */
  getLastLoginDateString(dateLastLogin: Date) {
    const today = dayjs(new Date());
    const loginDate = dayjs(dateLastLogin);
    const duration = dayjs.duration(today.diff(loginDate));

    let lastLoginDate = this.translate('lastLoginTpl', {
      timeStamp: loginDate.format('h:mm A'),
      numberOfDaysSinceLastLogin: duration.days(),
      numberOfHoursSinceLastLogin: duration.hours(),
      numberOfMinutesSinceLastLogin: duration.minutes()
    });

    return (
      <>
        <span
          className={'tp-viewport-footer-label tp-viewport-footer-last-login'}
        >
          {this.translate('lastLogin')}
        </span>
        <span>
          {lastLoginDate}
        </span>
      </>
    );
  }

  /**
   * @inheritDoc
   */
  renderBody() {
    const {
      dateLastLogin,
      numberOfActiveSessions = 1,
      pdInstanceIndicator
    } = this.state;
    const { impersonatedUser } = this.props;

    return (
      <div className={'tp-widget tp-viewport-footer'}>
        <div className={'tp-viewport-footer-left'}>
          {pdInstanceIndicator && (
            <span
              className={'tp-viewport-footer-instance-indicator tp-font-size-sm'}
            >{pdInstanceIndicator}</span>
          )}
        </div>
        <PuzzleToolbar className='tp-viewport-footer-right k-align-items-center'>
          {!impersonatedUser ? (
            <>
              <PuzzleButton
                fillMode="flat"
                size={'small'}
                onClick={this.openActiveSessions}
              >
                {numberOfActiveSessions ? this.translate('activeSessions', {
                  numberOfActiveSessions
                }) : null}
              </PuzzleButton>
              <span className={'tp-font-size-sm'}>
            {dateLastLogin ? this.getLastLoginDateString(dateLastLogin) : null}
          </span>
            </>
          ) : (<span>{this.translate('impersonatedUser')}</span>)}
        </PuzzleToolbar>
      </div>
    );
  }
}

export default Footer;
